import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../App';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Componente para verificar autenticação básica (login)
 * Diferente de ProtectedRoute que verifica permissões específicas
 */
export default function AuthenticatedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, setUser, loading, setLoading } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);

  useEffect(() => {
    // If user was passed from AuthCallback, use it
    if (location.state?.user) {
      setUser(location.state.user);
      setIsAuthenticated(true);
      setLoading(false);
      // Clear state
      window.history.replaceState({}, document.title);
      
      // Check first login for user from AuthCallback
      if (location.state.user.first_login === true && location.pathname !== '/primeiro-acesso') {
        navigate('/primeiro-acesso', { replace: true });
      }
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await axios.get(`${API}/auth/me`, {
          withCredentials: true
        });
        setUser(response.data);
        setIsAuthenticated(true);
        
        // Check first login
        if (response.data.first_login === true && location.pathname !== '/primeiro-acesso') {
          navigate('/primeiro-acesso', { replace: true });
        }
      } catch (error) {
        setIsAuthenticated(false);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    if (!user) {
      checkAuth();
    } else {
      setIsAuthenticated(true);
      setLoading(false);
      
      // Check first login for existing user
      if (user.first_login === true && location.pathname !== '/primeiro-acesso') {
        navigate('/primeiro-acesso', { replace: true });
      }
    }
  }, [location.state, navigate, setUser, setLoading, user, location.pathname]);

  if (isAuthenticated === null || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
